import { render, staticRenderFns } from "./YagiprimePaymentDialog.vue?vue&type=template&id=522474a4"
import script from "./YagiprimePaymentDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./YagiprimePaymentDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/payment/yagiprime-payment-dialog.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./YagiprimePaymentDialog.vue?vue&type=style&index=1&id=522474a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports